/* eslint-disable import/prefer-default-export */
import { TFunction } from "i18next"

export const costEstimateSummaryBreadCrumb = (t: TFunction<"translation", undefined>) => [
  {
    name: t("costEstimateSummary.breadCrumbHeading"),
  },
]
